import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/users/get/list.ts
var list_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var ContactSchema = z.object({
	first: z.string(),
	last: z.string(),
	mobile: z.string(),
	primaryContact: z.boolean(),
	sendBillingAlerts: z.boolean(),
	sendStreamingAlerts: z.boolean(),
	title: z.string()
});
var UserSchema = z.object({
	active: z.boolean(),
	address: z.string().nullable(),
	contact: ContactSchema.nullable(),
	emailVerified: z.boolean(),
	locked: z.boolean(),
	passwordResetRequired: z.boolean(),
	userName: z.string(),
	userPlanId: z.string(),
	userPlanName: z.string(),
	uuid: z.string()
});
var ResponseSchema = z.array(UserSchema);
var parse = parseFactory(ResponseSchema);
//#endregion
export { list_exports };

//# sourceMappingURL=list.js.map